import trackEvent from '@/common/js/track'
class Logs {
  async entry(params) {
    const { eventId, eventLabel, attrs = {} } = params;
    // 上报
    trackEvent({
      eventId,
      eventLabel,
      attrs
    })
  }
}

const log = new Logs();

/**
 * @desc 埋点上报
 * @param {Object} data
 * */
export function initTrackEvent(data) {
  return log.entry(data);
}
